module.exports = __webpack_public_path__ + "static/fonts/AvenirLTProBlack.9b6bd78.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProBlack.woff2
// module id = j8z5
// module chunks = 1